module.exports = __webpack_public_path__ + "img/sample_cabinet2.9b0e389c.png";